import type { AppProps } from 'next/app';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/browser';

import store from '~/src/store/index';
import { GlobalStyle } from '~/src/fonts/styled';
import { SingletonHooksContainer } from '~/src/containers/SingletonHook';
import 'bootswatch/dist/cosmo/bootstrap.min.css';

const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DSN;
Sentry.init({
    enabled: process.env.NEXT_PUBLIC_ENVIRONMENT === 'production',
    dsn: SENTRY_DSN,
});

const MyApp = ({ Component, pageProps }: AppProps): JSX.Element => {
    return <Provider store={store}>
        <SingletonHooksContainer/>
        <GlobalStyle/>
        <Component {...pageProps} />
    </Provider>;
};

export default MyApp;
